module.exports = __webpack_public_path__ + "static/media/error_icon.0792726d.png";